export const QUERY_EXPORT_REPORTS = `query ExportReports($reportIds: [String!]!) {
  exportReport(reportIds: $reportIds) {base64}
}`